module.exports = __webpack_public_path__ + "img/1280x720-Holiday.9a8b89eb.jpg";